<template>
    <div>
        <div class="about-banner">
            <img src="../../static/img/about.png" />
            <div class="about-banner-word">
                <span>关于我们 About Us</span>
                <img src="../../static/img/fb.png" @click="changeAboutNav" />
            </div>
        </div>
        <!-- 导航 -->
        <div class="about-nav-bg" v-if="isShowNav"></div>
        <div class="about-nav" v-if="isShowNav">
            <div class="top-nv">
                <span>关于我们</span>
                <img src="../../static/img/close.png" @click="closeAboutNav" />
            </div>
            <div class="about-nv-content">
                <ul>
                    <li @click="toAbout(index)" v-for="(item,index) in menu_active" :key="index">
                        <a>{{item.title}}</a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 导航 结束 -->
       <div class="aboutUs-tab-card" style="display:block;">
            <div class="about-title">
                公司起源
            </div>
            <div class="about-content">
                <p>西城区房屋土地经营管理中心是2002年5月从原西城区房屋土地管理局剥离出来，分立重组的，是一家自收自支的事业单位，承担着由区政府授权的房屋土地经营、管理、开发和服务职能。近几年，在完成好夏季防汛、冬季供暖、物业管理、零维修服务等常规任务的基础上，按照区委区政府的工作部署，先后承担了多项中央、市级、区级重点拆迁征收腾退项目及政府为民办实事专项重点工程。其中包括：街巷综合改造修缮、老旧小区环境综合整治、楼房抗震加固代建工程、老旧楼房加装电梯改造等重点工程，实施背街小巷物业管理、政府保障房项目物业管理等新兴业务，全面改善辖区居民的居住条件和生活环境，切实把政府惠及民生、改善民生的重要举措落到实处。</p>
                <p>2017年，按照国家及北京市出台的关于经营类事业单位转企改制的相关政策及西城区政府的要求，西城房地中心启动转企改制工作，成立改革领导小组，经过近一年时间，走出去、请进来、聚合力，反复研究、多次修改，制定出符合单位自身实际的转企改制方案，顺利通过职工代表大会、区政府专题会和区委常委会，于2017年12月25日，注册成立了北京德源兴业投资管理有限公司，实现了由自收自支事业单位到国有独资企业的历史性变革。
            目前，仍在深化转企改制阶段，正在积极研究推进后续配套工作，稳妥积极地推进改制方案落地。</p>
            </div>
       </div>
       <div class="aboutUs-tab-card">
           <div class="about-title">
               公司简介
            </div>
            <div class="about-content" v-html="companyjj"></div>
       </div>
       <div class="aboutUs-tab-card">
           <div class="about-title">
               主要职责
            </div>
            <div class="about-main-duty">
                <div class="duty-list" v-for="(item,index) in zyzhize" :key="index">
                    <p class="duty-img"><img :src="item.img" /></p>
                    <p class="duty-c">{{item.text}}</p>
                </div>
            </div>
       </div>
       <div class="aboutUs-tab-card">
           <div class="about-title">
               组织机构
            </div>
            <div class="about-main-duty" style="margin:.2rem; min-height:7rem;">
                <img src="../../static/img/zzjg.png" style=" width: 100%;" />

            </div>
       </div>
       <div class="aboutUs-tab-card">
           <div class="about-title">
               成员企业
            </div>
            <div class="about-main-member">
                <a href="javascript:;" v-for="(item,index) in cyqy_all" :key="index">{{item}}</a>
            </div>
       </div>
       <div class="aboutUs-tab-card">
           <div class="about-title">
               企业荣誉
            </div>
             <div class="honour">
                <img v-for="(item,index) in gsrongyu" :src="item" :key="index" />
               
            </div>
       </div>

    </div>
</template>

<script>
export default {
    data(){
        return {
            menu_active: [{
                'title': '公司起源',
                link: '',
                isActive: true,
            },
            {
                'title': '公司简介',
                link: '',
                isActive: false,
            },
            {
                'title': '主要职责',
                link: '',
                isActive: false,
            },
            {
                'title': '组织机构',
                link: '',
                isActive: false,
            },
            {
                'title': '成员企业',
                link: '',
                isActive: false,
            },
            {
                'title': '企业荣誉',
                link: '',
                isActive: false,
            }],
            cyqy_all: ['北京德源兴业投资管理集团有限公司',
                        '北京德源翔隆供暖技术服务有限责任公司',
                        '北京德源西长安街房屋管理有限公司',
                        '北京德源展览路房屋管理有限公司',
                        '北京德源新街口房屋管理有限公司',
                        '北京德源金融街房屋管理有限公司',
                        '北京德源什刹海房屋管理有限公司',
                        '北京德源德胜房屋管理有限公司',
                        '北京德源兴地房地产经营开发有限公司',
                        '北京德源月坛房屋管理有限公司',
                        '北京德源博风建筑工程有限公司',
                        '北京德源阜汇数字科技有限公司',
                        '京德源希诚房地产经纪服务有限公司',
                        '北京德源尚嘉城市更新置业发展有限公司',
                        '北京市西城区建设拆迁所有限公司',
                        '北京市育德建筑安装工程公司',
                        '北京德源佳安物业有限公司',
                        '北京德源佳德置业有限公司',
                        '北京德源佳宁安信房屋安全鉴定有限公司',
                        '北京德源汇宾出租汽车有限公司',
                        '北京德源营盈物业管理有限公司',
                        '北京市华暖汽车维修有限责任公司',
                        '北京月达拆迁服务有限责任公司',
                        '北京华佳兴业房屋拆迁服务有限责任公司',
                        '北京希诚装饰工程有限公司',
                        '北京市西城区建业培训学校',
                        '北京精功开拓投资开发有限公司',
                        '北京德源街佳力物业管理有限公司',
                        '北京德源佳誉拆迁服务有限公司',
                        '北京德源佳华酒店管理有限公司'
                        ],
            gsrongyu: [require('../assets/img/rongyu1.jpg'), require('../assets/img/rongyu2.jpg'), require('../assets/img/rongyu3.jpg'), require('../assets/img/rongyu4.jpg')],
            zyzhize: [
                {
                    text: '负责房屋的安全鉴定和测绘工作',
                    img: require('../assets/img/zhize1.png'),
                },
                {
                    text: '主要从事区政府授权直管公房等国有资产的经营和管理在经营活动和经营项目运作中，确保国有资产保值增值',
                    img:  require('../assets/img/zhize2.png'),
                },
                {
                    text: '负责房屋的安全检查、修缮和维修服务工作组织雨季防汛抢险和冬季供暖工作，确保居民住用安全',
                    img:  require('../assets/img/zhize3.png'),
                },
                {
                    text: '负责房屋设备安全管理服务工作',
                    img:  require('../assets/img/zhize4.png'),
                },
                {
                    text: '承办区政府交办的其他事',
                    img:  require('../assets/img/zhize5.png'),
                },
                {
                    text: '负责房地产开发、危旧房屋改造、房屋征收拆迁及中式房屋新建工作按照政府的有关要求和城市建设开发规划，受政府委托组织和实施危旧房改造工作，参与新建小区的物业管理，加大产业开发力度，促进产业发展，为弥补直管公房修缮资金不足提供保障',
                    img:  require('../assets/img/zhize6.png'),
                },
                {
                    text: '负责直管公房的经营、管理、服务工作负责租金的收缴，从事直管公房的物业管理、房地产交易、房屋租赁和房屋置换等经营服务业务；负责房地产咨询服务工作',
                    img:  require('../assets/img/zhize7.png'),
                },
            ],
            model: {
                test: 'hanxiao',
                phone: '',
            },
            honorImg: '', //企业荣誉
            companyjj: '', //公司简介
            isShowNav:false,
        }
    },
    methods:{
        getData:function(){
            var that=this;
            //企业荣誉
            that.$http.post(that.baseUrl+that.config.honorList,that.$qs.stringify(that.model)).then(function(ev){
                if(ev.data.code==100){
                    that.honorImg = ev.data.data;
                }
            }).catch(function(err){
                console.log(err);
            });
            //公司简介
            that.$http.post(that.baseUrl+that.config.company).then(function(ev){
                if(ev.data.code == 100){
                    console.log( ev.data.data);
                    that.companyjj = ev.data.data.company;
                }
            }).catch(function(error){
                console.log(error);
            })
        },
        changeAboutNav:function(){
            this.isShowNav=true;
        },
        closeAboutNav:function(){
            this.isShowNav=false;
        },
        toAbout:function(index){
            var that=this;
            var tabCardCollection = document.querySelectorAll(".aboutUs-tab-card"),
                    len = tabCardCollection.length;
                for (var i = 0; i < len; i++) {
                    tabCardCollection[i].style.display = "none";
                }
                //that.menu_active[tabIndex].isActive = true;
                tabCardCollection[index].style.display = "block";
                that.isShowNav = false;
        }
    },
    mounted(){
        this.baseUrl = window.baseUrl;
        this.config = window.config;
        this.getData();
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/aboutUs.vue